export const actionList = [
  {
    url: "/action-games",
    text: "Home",
  },
  {
    url: "/action-games/profile",
    text: "side_nav.profile",
    logged: true,
  },
  {
    url: "/action-games/my-games",
    text: "my_games",
    logged: true,
  },
  // {
  //   url: "/",
  //   text: "side_nav.my_coins",
  //   logged: true
  // },
  // {
  //   url: "/faqs",
  //   text: "side_nav.faq"
  // },
  {
    url: "/action-games/tos",
    text: "terms_and_conditions",
  },
  // {
  //   url: "/rules",
  //   text: "side_nav.rules"
  // },

  // {
  //   url: "/videoPlay",
  //   text: "side_nav.videos_tutorials"
  // },
  //  {
  //      url: "/payment",
  //     text: "payment_methods",
  //     logged: true
  //    },
  {
    url: "/action-games/change-language",
    text: "side_nav.language",
  },
  {
    url: "/action-games/logout",
    text: "side_nav.logout",
    logged: true,
  },
  {
    url: "/action-games/unsubscribe",
    text: "unsubscribe",
    logged: true,
  },
];
